import { ValidationResult } from './validation-result';
import { FormControl } from '@angular/forms';

export class EmailValidator {

    static valid(formEmail: FormControl): ValidationResult {
        const regex = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w{2,3}([-.]\w+)*$/;
        const email = formEmail.value;

        if (email === null ||
            email === '' ||
            email === undefined ) {
            return null;
        }

        const match = regex.exec(email);

        if (match === null) {
            return { 'pattern': true };
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/validators/emailPattern.validator.ts